import { OrbitControlsProps } from '@react-three/drei'
import { useFrame, useThree } from '@react-three/fiber'
import React from 'react'
import { useSpring } from 'react-spring'
import { Vector3 } from 'three'

interface SpringAnimateProps {
  initTarget: number[]
  initPosition: number[]
  orbitRef?: OrbitControlsProps | null
}

const SpringAnimate = ({
  initTarget,
  initPosition,
  orbitRef,
}: SpringAnimateProps) => {
  const { camera } = useThree()

  const [canAnimate, setCanAnimate] = React.useState<boolean>(false)
  const [target, setTarget] = React.useState(initTarget)
  const [position, setPosition] = React.useState(initPosition)

  const [springs, api] = useSpring(
    () => ({
      config: {
        mass: 5,
        tension: 280,
        friction: 120,
      },
      from: {
        target: initTarget,
        position: initPosition,
      },
    }),
    []
  )

  React.useEffect(() => {
    if (!canAnimate) {
      api.start({
        from: {
          target,
          position,
        },
        to: {
          target,
          position,
        },
      })
    }
  }, [canAnimate])

  useFrame(() => {
    if (canAnimate) {
      api.start({
        to: {
          target,
          position,
        },
        onChange: ({ value }) => {
          if (canAnimate) {
            if (orbitRef) {
              const orbitControl = orbitRef as OrbitControlsProps
              orbitControl.target = new Vector3(...value.target)
            }
            camera.position.fromArray(value.position)
            if (JSON.stringify(position) === JSON.stringify(value.position)) {
              setCanAnimate(false)
            }
          }
        },
      })
    }
  })

  return {
    canAnimate,
    target,
    position,
    setTarget,
    setPosition,
    setCanAnimate,
    springs,
  }
}

export default SpringAnimate
